(ns frontend.ui.page.lp-report-editor.step-2-data-gathering.fund-report.view
    (:require
     [clojure.string :as string]
     [frontend.ui.page.lp-portal.report.view :as report-view]
     [frontend.ui.page.lp-report-editor.common.event :as common-event]
     [frontend.ui.page.lp-report-editor.common.modal.pdf-preview-modal :as pdf-preview-modal]
     [frontend.ui.page.lp-report-editor.common.view :refer [close-button
                                                            footer
                                                            preview-pdf-button]]
     [frontend.ui.page.lp-report-editor.step-2-data-gathering.buttons :as buttons]
     [frontend.ui.page.lp-report-editor.step-2-data-gathering.fund-report.event :as event]
     [frontend.ui.page.lp-report-editor.step-2-data-gathering.sub :as sub]
     [frontend.ui.page.lp-report-editor.style :as editor-style]
     [frontend.ui.page.lp-report-editor.sub :as editor-sub]
     [herb.core :refer [<class]]
     [re-frame.core :as rf]))

(defn step-footer
  [report]
  (let [rid (:db/id report)
        main-report @(rf/subscribe [::editor-sub/lp-report])
        can-edit-text? @(rf/subscribe [::sub/has-edit-fund-texts-access?])
        can-approve-text? @(rf/subscribe [::sub/can-approve-report-texts?])
        can-edit-data? @(rf/subscribe [::sub/has-edit-fund-data-access?])
        can-approve-data? @(rf/subscribe [::sub/can-approve-report-data?])
        text-reject-recipients @(rf/subscribe [::sub/text-reject-recipients rid])
        submit-recipients @(rf/subscribe [::sub/text-submit-recipients rid])
        data-reject-recipients @(rf/subscribe [::sub/data-reject-recipients rid])
        data-submit-recipients @(rf/subscribe [::sub/data-submit-recipients rid])
        report-rich-content-list @(rf/subscribe [::sub/report-rich-content-list])
        feeder? false]
    
    [footer
     {:left-content
      [:<>
       [close-button {:on-click #(rf/dispatch [::event/close-viewer])}]
       [:div
        [pdf-preview-modal/view
         {:on-close #(rf/dispatch [::common-event/close-pdf-preview])
          :report main-report}]
        [preview-pdf-button
         {:on-click #(rf/dispatch [::common-event/open-pdf-preview main-report feeder?])}]]]

      :right-content
      [:<>
       ;; text buttons
       [buttons/fund-text-buttons
        feeder?
        report
        submit-recipients
        report-rich-content-list
        [::event/submit-for-review-text rid]
        [::event/submit-for-review-text-confirm rid]
        text-reject-recipients
        [::event/reject-text rid]
        [::event/on-reject-confirmed rid]
        [::event/approve-text rid]
        can-edit-text?
        can-approve-text?]

       ;; data buttons
       [buttons/fund-data-buttons
        report
        data-submit-recipients
        [::event/submit-for-review-data rid]
        [::event/submit-for-review-data-confirm rid]
        data-reject-recipients
        [::event/reject-data rid]
        [::event/reject-data-confirm rid]
        [::event/approve-data rid]
        can-edit-data?
        can-approve-data?]]}]))


(defn view
  []
  (let [report @(rf/subscribe [::editor-sub/lp-report])
        fund-report-id @(rf/subscribe [::sub/fund-report-id])
        fund-report-ui-data @(rf/subscribe [::editor-sub/fund-report-ui-data fund-report-id])
        can-edit-fund-texts? @(rf/subscribe [::sub/can-edit-fund-texts?])
        can-edit-fund-data? @(rf/subscribe [::sub/can-update-report-data?])
        can-edit-footer? @(rf/subscribe [::sub/can-edit-fund-footer-texts?])
        ;;Editable tables and charts
        can-edit-fund-charts-and-tables? (or can-edit-fund-texts? can-edit-fund-data?)
        save-text (fn [edit-path edit-value complete-path complete-status]
                    (rf/dispatch [::event/save-fund-report-text fund-report-id
                                  edit-path edit-value
                                  complete-path complete-status]))
        save-image-with-text (fn [edit-path edit-value complete-path complete-status]
                               (rf/dispatch [::event/save-fund-report-image fund-report-id
                                             edit-path edit-value
                                             complete-path complete-status]))
        save-report-image-to-s3 (fn [edit-path edit-value complete-path complete-status]
                                  (rf/dispatch [::event/save-fund-report-image-to-s3 fund-report-id
                                                edit-path edit-value
                                                complete-path complete-status]))
        save-chart-configs (fn [edit-path edit-value on-success!]
                             (rf/dispatch [::event/save-fund-report-chart-configs
                                           fund-report-id
                                           on-success!
                                           edit-path edit-value]))
        save-table-data (fn [edit-path edit-value on-success!]
                          (rf/dispatch [::event/save-fund-report-table-data fund-report-id on-success!
                                        edit-path edit-value]))
        wip-data? (= :lp-report.publishing-status/wip (:lp-report/data-status report))]
    [:<>
     (when wip-data?
       [:div
        {:class (<class editor-style/page-watermark-container)}
        [:div
         {:class (<class editor-style/page-watermark)}
         (->> (range 0 2000)
              (map (fn [_i]
                     "Draft data"))
              (string/join " - "))]])
     [:div
      {:class (<class editor-style/page-body)}
      [:div
       {:class (<class editor-style/page-content)}
       [report-view/fund-report-content
        {:fund-ui-data         fund-report-ui-data
         :report               report
         :fund-template-type   (:lp-report/template-type report)
         :edit-mode?           can-edit-fund-texts?
         :chart-edit?          can-edit-fund-charts-and-tables?
         :chart-select?        can-edit-fund-charts-and-tables?
         :table-edit?          can-edit-fund-charts-and-tables?
         :table-select?        can-edit-fund-charts-and-tables?
         :show-draft?          true
         :edit-mode-footer?    can-edit-footer?
         :save-text            save-text
         :save-image-with-text save-image-with-text
         :save-report-image-to-s3 save-report-image-to-s3
         :save-table-data      save-table-data
         :save-chart           save-table-data
         :save-chart-configs   save-chart-configs}]

       (when (:lp-report/template-type report)
         [report-view/last-content                          ;; Needed for displaying the contents that are ordered after holdings, if any.
          {:fund-ui-data         fund-report-ui-data
           :report               report
           :fund-template-type   (:lp-report/template-type report)
           :edit-mode?           can-edit-fund-texts?
           :show-draft?          true
           :edit-mode-footer?    can-edit-footer?
           :save-text            save-text
           :save-image-with-text save-image-with-text
           :save-report-image-to-s3 save-report-image-to-s3}])]]
     [step-footer report]]))
